module.exports = __webpack_public_path__ + "img/CtrlRoom_wifi_off.2f81a5d4.png";